enum AccessReportStatusEnum {
  Unknown = "Unknown",
  Created = "Created",
  Running = "Running",
  Succeeded = "Succeeded",
  Failed = "Failed",
  Canceled = "Canceled",
}

export { AccessReportStatusEnum };
